{{gate}}
<div *ngIf="!!line" class="indexes">
	<div class="index">{{line}}</div>
</div>
